import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VisitCounter() {
  const [stats, setStats] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Record visit
    recordVisit();
    // Fetch stats
    fetchStats();
  }, []);

  const recordVisit = async () => {
    try {
      await axios.post(`${API}/analytics/visit`);
    } catch (error) {
      // Silent fail
    }
  };

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/analytics/stats`);
      setStats(response.data);
    } catch (error) {
      // Silent fail
    }
  };

  const formatNumber = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num.toString();
  };

  if (!stats) return null;

  return (
    <div 
      className="fixed bottom-4 left-4 z-40"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      data-testid="visit-counter"
    >
      {/* Minimal indicator (always visible) */}
      <div className="flex items-center gap-1.5 px-2 py-1 bg-[#0a0a0a]/80 backdrop-blur border border-[#262626]/50 rounded-full text-xs text-gray-500 cursor-default">
        <span className="w-1.5 h-1.5 rounded-full bg-[#00FF94] animate-pulse" />
        <span className="font-mono">{formatNumber(stats.total_visits)}</span>
      </div>

      {/* Expanded stats (on hover) */}
      {show && (
        <div className="absolute bottom-full left-0 mb-2 p-3 bg-[#0a0a0a] border border-[#262626] rounded-lg shadow-xl min-w-[160px] animate-fade-in">
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-xs text-gray-500">Visitors</span>
              <span className="text-xs text-white font-mono">{formatNumber(stats.total_visits)}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-xs text-gray-500">Protected</span>
              <span className="text-xs text-[#00FF94] font-mono">{formatNumber(stats.users_protected)}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-xs text-gray-500">Threats Blocked</span>
              <span className="text-xs text-white font-mono">{formatNumber(stats.threats_blocked)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
